export const ExchangeMapping = {
    embedUrl: 'specific.exchange.embedUrl'
};
